import { useState, useEffect } from "react";
import { DocumentSnapshot, FirestoreError } from "@firebase/firestore-types";
import { Submitter } from "@comparaonline/ui-checkout-cico";
import { updateCheckout, onCheckoutSnapshot } from "../store/cicoCheckout";
import { FirebaseClient } from "../types";

const getOnUpdate = (formId: string, firebase: FirebaseClient): Submitter => async (
  values,
  subcollections
) => {
  await updateCheckout(formId, values, subcollections, firebase);
};

export const useCheckoutForm = (formId: string, firebase: FirebaseClient) => {
  const [checkoutForm, setCheckoutForm] = useState<CheckoutForm | undefined>();
  const [error, setError] = useState<FirestoreError | undefined>();

  const snapshotHandler = (checkoutSnapshot: DocumentSnapshot) => setCheckoutForm(checkoutSnapshot);
  const snapshotErrorHandler = (error: FirestoreError) => setError(error);

  useEffect(() => {
    if (formId && firebase) {
      onCheckoutSnapshot(formId, firebase, snapshotHandler, snapshotErrorHandler);
    }
  }, [formId, firebase]);

  return {
    error,
    checkoutForm,
    loading: !Boolean(checkoutForm),
    onUpdateCheckoutForm: getOnUpdate(formId, firebase)
  };
};
